import { render, staticRenderFns } from "./ModalHousing.vue?vue&type=template&id=297a945c&"
import script from "./ModalHousing.vue?vue&type=script&lang=js&"
export * from "./ModalHousing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports